import React from 'react';
import PropTypes from 'prop-types';

import ProgressBar from 'react-toolbox/lib/progress_bar/ProgressBar';
import Button from 'react-toolbox/lib/button/Button';

import Details from "../containers/Details";
import {ScreenCentered, StandaloneForm, ThemedHeader} from '../../Styled';

const Payments = ({isFilled, submit, submitWaiting, submitSuccess, submitFailure}) => {
    return (
        <ScreenCentered>
            <StandaloneForm>
                <ThemedHeader>Easy Pay!</ThemedHeader>

                <div style={{marginBottom: "50px"}}>
                    <Details/>
                </div>

                {!submitWaiting && !submitSuccess && !submitFailure &&
                 <Button icon='payment' label='Pay with Card' raised primary disabled={!isFilled} onClick={submit}/>}

                {submitWaiting &&
                 <ProgressBar type="circular" mode="indeterminate"/>}

                {submitSuccess &&
                 <strong style={{color: 'green'}}>Your card has been charged. Thank you!</strong>}

                {submitFailure &&
                 <strong style={{color: 'red'}}>Something went wrong! Please let us know and try again later.</strong>}
            </StandaloneForm>
        </ScreenCentered>
    )
};

Payments.propTypes = {
    isFilled:      PropTypes.bool.isRequired,
    submit:        PropTypes.func.isRequired,
    submitWaiting: PropTypes.bool.isRequired,
    submitSuccess: PropTypes.bool.isRequired,
    submitFailure: PropTypes.bool.isRequired
};

export default Payments;



// WEBPACK FOOTER //
// ./src/app/payments/components/Payments.js